import { useEffect, useState, RefObject } from "react";

export function useElementScrollable(elementRef: RefObject<HTMLElement>) {
    const [isScrollable, setIsScrollable] = useState(false);

    useEffect(() => {
        const element = elementRef.current;

        if (!element) return;

        const updateScrollable = () => {
            setIsScrollable(element.scrollHeight > element.clientHeight);
        };

        const resizeObserver = new ResizeObserver(updateScrollable);
        resizeObserver.observe(element);

        // Initial check
        updateScrollable();

        return () => {
            resizeObserver.unobserve(element);
        };
    }, [elementRef]);

    return isScrollable;
}
